import breadcrumbComp from "../../common/breadcrumb-comp.vue";
import Utility from "../../../shared/utility";
import EncryptUtility from "../../utility/js/encrypt-utility";
import AddFavourite from "../../utility/js/addFav";
import shippingService from "./shipping-service";
import html2pdf from "html2pdf.js";
import BackToTop from "../../common/back-to-top.vue";
import PrinterDetails from "../../common/printer-details";
import ReadMore from "../../common/read-more.vue";
export default {
  name: "Generate Pull Sheet",
  data() {
    return {
      expanded: [],
      userId: EncryptUtility.localStorageDecrypt("userID"),
      primaryName: EncryptUtility.localStorageDecrypt("primaryName"),
      defaultName: EncryptUtility.localStorageDecrypt("defaultName"),
      disablePDFPrint: false,
      actionList: [],
      arrayData: [],
      favouriteList: [],
      totalRecords: 0,
      mainPage: "",
      searchFilter: "",
      filterOrderType: "",
      filterStatus: "",
      filterCarrier: "",
      selectedProcess: "",
      selectedProject: "",
      selectedBusiness: "",
      subPage: "",
      backSlash: true,
      pageUrl: "",
      showAdd: false,
      refresh: true,
      soSearch: "",
      poSearch: "",
      disableProject: true,
      disableBusiness: true,
      disableOrderType: true,
      disableCarrier: true,
      showFilter: false,
      disableCountry: true,
      disableWarehouse: true,
      disablePartNumber: true,
      selectedIntRule: [(v) => parseInt(v) >= 0 || "Field is required"],
      disableRun: true,
      warehouseList: [],
      orderType: "",
      selectedStatus: "",
      selectedCountry: "",
      required: [(v) => !!v || "This field is required"],
      route: "",
      pdfName: "",
      pullSheetDataTemp: [],
      pullSheetTemp: [],
      uniqueCarrier: [],
      uniqueOtype: [],
      uniqueBusiness: [],
      uniqueStatus: [],
      processsTypeList: [],
      projectList: [],
      projectIds: [],
      businessList: [],
      businessIds: [],
      orderTypeList: [],
      orderTypes: [],
      carrierList: [],
      carrierIds: [],
      countryList: [],
      countryLists: [],
      warehouseIds: [],
      partNumList: [],
      statusList: [],
      partNumIds: [],
      pullSheetData: [],
      showPrimary: true,
      pullSheetHeader: [
        {
          text: "View",
          value: "View",
          class: "primary customwhite--text",
          width: "3%",
        },
        {
          text: "Type",
          value: "Type",
          class: "primary customwhite--text",
          width: "3%",
        },
        {
          text: "Order Number",
          value: "OrderNo",
          class: "primary customwhite--text",
          width: "8%",
        },
        {
          text: "Order Type",
          value: "Order_Type",
          class: "primary customwhite--text",
          width: "4%",
        },
        {
          text: "Company",
          value: "Company",
          class: "primary customwhite--text",
          width: "9%",
        },
        {
          text: "Ship By Date",
          value: "Ship_By_Date",
          class: "primary customwhite--text",
          sortable: true,
          width: "9%",
        },
        {
          text: "Ordered Date",
          value: "OrderDate",
          class: "primary customwhite--text",
          sortable: true,
          width: "9%",
        },

        {
          text: "Carrier",
          value: "SLevel",
          class: "primary customwhite--text",
          width: "9%",
        },
        {
          text: "Alloc",
          value: "Alloc",
          class: "primary customwhite--text",
          width: "5%",
        },
        {
          text: "Status",
          value: "Status",
          class: "primary customwhite--text",
          width: "18%",
        },
        {
          text: "New Hire",
          value: "HireDate",
          class: "primary customwhite--text",
          width: "23%",
        },
        {
          text: "",
          value: "data-table-expand",
          class: "primary customwhite--text",
        },
      ],
      selectedOrders: [],
      orderFilterJSON: {
        process_list: [],
        projkey_list: [],
        bukey_list: [],
        otype_list: [],
        slkey_list: [],
        country_list: [],
        warekey_list: [],
        part_number: [],
        status_list: [],
      },
      pullSheetLink: "",
      pullSheetDialog: false,
      exportDisable: true,
      max50Rule: [(v) => (v || "").length <= 50 || "Max Length of 50 character"],
      excelName: "",
      json_fields: {
        Type: "Type",
        "Order Number": "OrderNo",
        "Order Type": "Order_Type",
        Company: "Company",
        "Ship By Date": "Ship_By_Date",
        "Ordered Date": "OrderDate",
        Carrier: "SLevel",
        Allocation: "Alloc",
        Status: "Status",
        "New Hire": "HireDate",
        Notes: "Note",
      },
    };
  },
  async created() {
    this.route = this.$route.path.replace("/", "");
    let data = await AddFavourite.getPageAction(this.userId, this.route);
    this.actionList = data.actionList;
    this.mainPage = data.mainPage;
    this.favouriteList = data.favouriteList;
    this.pageUrl = data.pageUrl;
    this.subPage = data.subPage;
    this.showAdd = data.showAdd;
    if (EncryptUtility.localStorageDecrypt("pullSheetQuickSearch")) {
      let obj = JSON.parse(EncryptUtility.localStorageDecrypt("pullSheetQuickSearch"));
      if (obj?.ordno) {
        this.showFilter = false;
        if (obj.type == "SO") {
          this.orderType = "SO";
          this.soSearch = obj?.ordno;
          let resData = await shippingService.onSearchPullSheet("post", obj);
          resData.forEach((item) => {
            item.OrderDate = Utility.displayDateFormat(item.OrderDate);
            item.ReqDate = item.ReqDate ? Utility.displayDateFormat(item.ReqDate) : "";
            item.Ship_By_Date = item.Ship_By_Date ? Utility.displayDateFormat(item.Ship_By_Date, "MM/DD/YYYY hh:mm:ss") : "";
            item.HireDate = item.HireDate ? Utility.displayDateFormat(item.HireDate, "MM/DD/YYYY") : "";
          });
          this.pullSheetData = resData;
          this.exportDisable = false;
          this.totalRecords = resData?.length;
          this.setAutoExpanded();
        } else {
          this.orderType = "PO";
          this.poSearch = obj?.ordno;
          let resData = await shippingService.onSearchPullSheet("post", obj);
          resData.forEach((item) => {
            item.OrderDate = Utility.displayDateFormat(item.OrderDate);
            item.ReqDate = item.ReqDate ? Utility.displayDateFormat(item.ReqDate) : "";
            item.Ship_By_Date = item.Ship_By_Date ? Utility.displayDateFormat(item.Ship_By_Date, "MM/DD/YYYY hh:mm:ss") : "";
            item.HireDate = item.HireDate ? Utility.displayDateFormat(item.HireDate, "MM/DD/YYYY") : "";
          });
          this.pullSheetData = resData;
          this.exportDisable = false;
          this.totalRecords = resData?.length;
          this.setAutoExpanded();
        }
      }
    }
    if (EncryptUtility.localStorageDecrypt("filterObjects")) {
      let storedArray = JSON.parse(EncryptUtility.localStorageDecrypt("filterObjects"));
      this.arrayData = storedArray;
    }
    if (EncryptUtility.localStorageDecrypt("defaultName") !== null && EncryptUtility.localStorageDecrypt("defaultName") !== undefined) {
      this.disablePDFPrint = false;
    }
  },
  async mounted() {
    let processObj = {
      UserID: this.userId,
      ddl_pass: 1,
      processType: "",
      projkey_list: "",
      bukey_list: "",
      otype_list: "",
      slkey_list: "",
      country_list: "",
      warekey_list: "",
      status_list: "",
    };
    let processType = await shippingService.generatePullSheetFilters("post", processObj);
    Array.isArray(processType) ? (this.processsTypeList = processType) : (this.processsTypeList = []);
    if (EncryptUtility.localStorageDecrypt("pullSheetFilterSearch")) {
      let obj = JSON.parse(EncryptUtility.localStorageDecrypt("pullSheetFilterSearch"));
      let ObjectJson = JSON.parse(EncryptUtility.localStorageDecrypt("pullSheetFilterSearch")).json;
      ObjectJson = JSON.parse(ObjectJson);
      this.showFilter = true;
      this.selectedProcess = ObjectJson?.process_list[0];
      this.selectedProject = ObjectJson?.projkey_list[0];
      this.selectedBusiness = ObjectJson?.bukey_list[0];
      this.selectedStatus = ObjectJson?.status_list[0];
      this.selectedCountry = ObjectJson?.country_list[0];
      this.projectAPI(this.selectedProcess), this.businessAPI(this.selectedProject);
      this.statusAPI(this.selectedBusiness);
      this.countryAPI();
      this.disableProject = false;
      this.disableBusiness = false;
      this.disableOrderType = false;
      this.disableCarrier = false;
      this.disableCountry = false;
      this.disableWarehouse = false;
      this.disablePartNumber = false;
      this.disableRun = false;
      let resData = await shippingService.onFilterPullSheet("post", obj);
      if (resData?.message == "NA") {
        let Alert = {
          type: "error",
          isShow: true,
          message: "No Result Found",
        };
        this.$store.commit("ConfigModule/Alert", Alert);
        this.totalRecords = 0;
        this.pullSheetData = [];
      } else {
        this.orderType = resData[0]?.Type == "SO" ? "SO" : "PO";
        resData.forEach((item) => {
          item.OrderDate = Utility.displayDateFormat(item.OrderDate);
          item.ReqDate = item.ReqDate ? Utility.displayDateFormat(item.ReqDate) : "";
          item.Ship_By_Date = item.Ship_By_Date ? Utility.displayDateFormat(item.Ship_By_Date, "MM/DD/YYYY hh:mm:ss") : "";
          item.HireDate = item.HireDate ? Utility.displayDateFormat(item.HireDate, "MM/DD/YYYY") : "";
        });
        this.pullSheetData = resData;
        this.exportDisable = false;
        this.pullSheetTemp = resData;
        this.totalRecords = resData?.length;
        this.setAutoExpanded();
      }
    }
  },
  computed: {
    frameSrc() {
      return `data:application/pdf;base64,${this.pullSheetLink}#toolbar=0`;
    },
  },
  methods: {
    setAutoExpanded() {
      this.$nextTick(() => {
        this.expanded = this.pullSheetData.filter((row) => row?.Note && row.Note.trim() !== "");
      });
    },
    addFav() {
      this.showAdd = !this.showAdd;
      AddFavourite.add_remove_Favourite(this.showAdd, this.userId, this.route);
    },
    printDetails() {
      if (EncryptUtility.localStorageDecrypt("defaultName") !== null && EncryptUtility.localStorageDecrypt("defaultName") !== undefined) {
        let poId = [],
          soId = [];
        if (this.selectedOrders?.length > 0) {
          this.selectedOrders.forEach((element) => {
            if (element?.so_id > 0) {
              soId.push(element?.so_id);
            }
            if (element?.po_id > 0) {
              poId.push(element?.po_id);
            }
          });
          if (soId) {
            soId = soId?.join(",");
          }
          if (poId) {
            poId = poId?.join(",");
          }
          let LoaderDialog = {
            visible: true,
            title: "Please Wait...",
          };
          this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
          let obj = {
            user_id: parseInt(this.userId),
            po_id: poId,
            so_id: soId,
            purno: "",
            sono: "",
          };
          this.axios
            .post("sh/shipping_pullsheet_report", obj)
            .then((response) => {
              if (response.status == 200 || response.status == 204) {
                this.pdfName = "Order_Details_" + ".pdf";
                let responseData = response.data.body.message;
                Utility.printZPLPDF(responseData, EncryptUtility.localStorageDecrypt("defaultName"));
              } else {
                LoaderDialog.visible = false;
                this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
                let Alert = {
                  type: "error",
                  isShow: true,
                  message: response.data.message,
                };
                this.$store.commit("ConfigModule/Alert", Alert);
              }
              LoaderDialog.visible = false;
              this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
            })
            .catch((error) => {
              LoaderDialog.visible = false;
              this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
              let Alert = {
                type: "error",
                isShow: true,
                message: Utility.apiError(error),
              };
              this.$store.commit("ConfigModule/Alert", Alert);
            });
        } else {
          let Alert = {
            type: "error",
            isShow: true,
            message: "Please select any Order Number to Print",
          };
          this.$store.commit("ConfigModule/Alert", Alert);
        }
      } else {
        let Alert = {
          type: "error",
          isShow: true,
          message: "Default Printer is not configured, please configure printer.",
        };
        this.$store.commit("ConfigModule/Alert", Alert);
      }
    },
    selectAllToggle(props) {
      if (this.selectedOrders.length == 0) {
        this.selectedOrders = [];
        const self = this;
        props.items.forEach((item) => {
          if (item.Alloc == "Y") {
            self.selectedOrders.push(item);
          }
        });
      } else {
        this.selectedOrders = [];
      }
    },
    async projectAPI(data) {
      this.orderFilterJSON.process_list = [];
      this.orderFilterJSON.process_list.push(data);
      let projectObj = {
        UserID: this.userId,
        ddl_pass: 2,
        process_list: JSON.stringify(this.orderFilterJSON.process_list),
        projkey_list: "",
        bukey_list: "",
        otype_list: "",
        slkey_list: "",
        country_list: "",
        warekey_list: "",
      };
      let projectData = await shippingService.generatePullSheetFilters("post", projectObj);
      this.projectList = projectData;
    },
    async businessAPI(data) {
      this.orderFilterJSON.projkey_list = [];
      this.orderFilterJSON.projkey_list.push(data);
      let businessObj = {
        UserID: this.userId,
        ddl_pass: 3,
        process_list: JSON.stringify(this.orderFilterJSON.process_list),
        projkey_list: JSON.stringify(this.orderFilterJSON.projkey_list),
        bukey_list: "",
        otype_list: "",
        slkey_list: "",
        country_list: "",
        warekey_list: "",
      };
      let businessData = await shippingService.generatePullSheetFilters("post", businessObj);
      let busidata = this.getBusinessDataOrEmptyString(businessData);
      this.businessList = busidata;
    },
    getBusinessDataOrEmptyString(apiResponse) {
      if (Array.isArray(apiResponse) && apiResponse.every((item) => typeof item === "object" && item !== null)) {
        return apiResponse;
      } else {
        return [];
      }
    },
    async orderTypeAPI(data) {
      this.orderFilterJSON.otype_list = [];
      this.orderFilterJSON.otype_list.push(data);
      let orderTypeObj = {
        UserID: this.userId,
        ddl_pass: 4,
        process_list: JSON.stringify(this.orderFilterJSON.process_list),
        projkey_list: JSON.stringify(this.orderFilterJSON.projkey_list),
        bukey_list: JSON.stringify(this.orderFilterJSON.otype_list),
        otype_list: "",
        slkey_list: "",
        country_list: "",
        warekey_list: "",
      };
      let orderTypeData = await shippingService.generatePullSheetFilters("post", orderTypeObj);
      this.orderTypeList = orderTypeData;
    },
    onChangeProcess(item) {
      if (!item) {
        this.disableProject = true;
        this.projectList = [];
        this.selectedProject = "";
        this.businessList = [];
        this.selectedBusiness = "";
        this.statusList = [];
        this.selectedStatus = "";
        this.countryList = [];
        this.selectedCountry = "";
        this.disableBusiness = true;
        this.disableCountry = true;
        this.disableRun = true;
        this.orderFilterJSON.process_list = [];
        this.orderFilterJSON.projkey_list = [];
        this.orderFilterJSON.bukey_list = [];
        this.orderFilterJSON.status_list = [];
        this.orderFilterJSON.country_list = [];
        this.pullSheetData = [];
        this.showFilter = false;
        this.totalRecords = 0;
        this.expanded = [];
        return;
      }
      this.disableProject = false;
      this.projectAPI(item);
      this.disableBusiness = true;
      this.disableOrderType = true;
      this.disableCarrier = true;
      this.disableCountry = true;
      this.disableWarehouse = true;
      this.disablePartNumber = true;
      this.orderFilterJSON.projkey_list = [];
      this.orderFilterJSON.status_list = [];
      this.orderFilterJSON.bukey_list = [];
      this.orderFilterJSON.otype_list = [];
      this.orderFilterJSON.slkey_list = [];
      this.orderFilterJSON.country_list = [];
      this.orderFilterJSON.warekey_list = [];
      this.selectedStatus = "";
      this.pullSheetData = [];
      this.selectedProject = "";
      this.selectedCountry = "";
      this.selectedBusiness = "";
      this.disableRun = true;
      this.showFilter = false;
      this.totalRecords = 0;
      this.expanded = [];
    },
    async onChangeProject(project) {
      if (!project) {
        this.disableBusiness = true;
        this.businessList = [];
        this.selectedBusiness = "";
        this.statusList = [];
        this.selectedStatus = "";
        this.countryList = [];
        this.selectedCountry = "";
        this.disableCountry = true;
        this.disableRun = true;
        this.orderFilterJSON.projkey_list = [];
        this.orderFilterJSON.bukey_list = [];
        this.orderFilterJSON.status_list = [];
        this.orderFilterJSON.country_list = [];
        this.pullSheetData = [];
        this.showFilter = false;
        this.totalRecords = 0;
        this.expanded = [];
        return;
      }
      this.orderFilterJSON.projkey_list = [];
      this.orderFilterJSON.projkey_list.push(project);
      this.disableBusiness = false;
      this.businessAPI(project);
      this.disableOrderType = true;
      this.disableCarrier = true;
      this.disableCountry = true;
      this.disableWarehouse = true;
      this.disablePartNumber = true;
      this.orderFilterJSON.bukey_list = [];
      this.pullSheetData = [];
      this.showFilter = false;
      this.totalRecords = 0;
      this.orderFilterJSON.otype_list = [];
      this.orderFilterJSON.status_list = [];
      this.orderFilterJSON.slkey_list = [];
      this.orderFilterJSON.country_list = [];
      this.orderFilterJSON.warekey_list = [];
      this.selectedBusiness = "";
      this.selectedStatus = "";
      this.selectedCountry = "";
      this.disableRun = true;
      this.expanded = [];
    },
    async onChangeBusiness() {
      if (!this.selectedBusiness) {
        this.statusList = [];
        this.selectedStatus = "";
        this.countryList = [];
        this.selectedCountry = "";
        this.disableCountry = true;
        this.disableRun = true;
        this.orderFilterJSON.bukey_list = [];
        this.orderFilterJSON.status_list = [];
        this.orderFilterJSON.country_list = [];
        this.pullSheetData = [];
        this.showFilter = false;
        this.totalRecords = 0;
        this.expanded = [];
        return;
      }
      this.orderFilterJSON.status_list = [];
      this.disableOrderType = false;
      this.pullSheetData = [];
      this.showFilter = false;
      this.totalRecords = 0;
      this.statusAPI(this.selectedBusiness);
      this.selectedStatus = "";
      this.selectedCountry = "";
      this.expanded = [];
    },
    async onChangeStatus() {
      if (!this.selectedStatus && this.selectedStatus !== 0) {
        this.countryList = [];
        this.selectedCountry = "";
        this.disableCountry = true;
        this.disableRun = true;
        this.orderFilterJSON.status_list = [];
        this.orderFilterJSON.country_list = [];
        this.pullSheetData = [];
        this.showFilter = false;
        this.totalRecords = 0;
        this.expanded = [];
        return;
      }
      this.pullSheetData = [];
      this.showFilter = false;
      this.totalRecords = 0;
      this.disableCountry = false;
      this.selectedCountry = "";
      this.disableRun = true;
      this.orderFilterJSON.status_list = [];
      this.orderFilterJSON.status_list.push(this.selectedStatus);
      this.countryAPI();
      this.expanded = [];
    },
    async countryAPI() {
      let statusObj = {
        UserID: this.userId,
        ddl_pass: 6,
        process_list: JSON.stringify(this.orderFilterJSON.process_list),
        projkey_list: JSON.stringify(this.orderFilterJSON.projkey_list),
        bukey_list: JSON.stringify(this.orderFilterJSON.otype_list),
        status_list: JSON.stringify(this.orderFilterJSON.status_list),
      };
      let countryData = await shippingService.generatePullSheetFilters("post", statusObj);
      this.countryList = countryData;
    },
    onChangeCountry() {
      if (!this.selectedCountry) {
        this.orderFilterJSON.country_list = [];
        this.disableRun = true;
        this.pullSheetData = [];
        this.showFilter = false;
        this.totalRecords = 0;
        this.expanded = [];
        return;
      }
      this.orderFilterJSON.country_list = [];
      this.orderFilterJSON.country_list.push(this.selectedCountry);
      this.disableRun = false;
      this.pullSheetData = [];
      this.showFilter = false;
      this.totalRecords = 0;
      this.expanded = [];
    },
    async onClickRun() {
      this.selectedOrders = [];
      this.soSearch = "";
      this.poSearch = "";
      this.orderFilterJSON.process_list = [];
      this.orderFilterJSON.projkey_list = [];
      this.orderFilterJSON.status_list = [];
      this.orderFilterJSON.bukey_list = [];
      this.orderFilterJSON.country_list = [];
      this.orderFilterJSON.status_list = [];
      this.orderFilterJSON.process_list.push(this.selectedProcess);
      this.orderFilterJSON.projkey_list.push(this.selectedProject);
      this.orderFilterJSON.bukey_list.push(this.selectedBusiness);
      this.orderFilterJSON.status_list.push(this.selectedStatus);
      this.orderFilterJSON.country_list.push(this.selectedCountry);
      let submitObj = {
        userId: this.userId,
        json: JSON.stringify({
          process_list: this.orderFilterJSON.process_list,
          projkey_list: this.orderFilterJSON.projkey_list,
          bukey_list: this.orderFilterJSON.bukey_list,
          otype_list: [],
          status_list: this.orderFilterJSON.status_list,
          country_list: this.orderFilterJSON.country_list,
          warekey_list: [],
          partnum_list: [],
        }),
      };
      let resData = await shippingService.onFilterPullSheet("post", submitObj);
      if (resData.message == "NA") {
        let Alert = {
          type: "error",
          isShow: true,
          message: "No Result Found",
        };
        this.$store.commit("ConfigModule/Alert", Alert);
        this.totalRecords = 0;
        this.pullSheetData = [];
        this.expanded = [];
      } else {
        this.showFilter = true;
        this.orderType = resData[0].Type == "SO" ? "SO" : "PO";
        resData.forEach((item) => {
          item.OrderDate = Utility.displayDateFormat(item.OrderDate);
          item.ReqDate = item.ReqDate ? Utility.displayDateFormat(item.ReqDate) : "";
          item.Ship_By_Date = item.Ship_By_Date ? Utility.displayDateFormat(item.Ship_By_Date, "MM/DD/YYYY hh:mm:ss") : "";
          item.HireDate = item.HireDate ? Utility.displayDateFormat(item.HireDate, "MM/DD/YYYY") : "";
        });
        this.pullSheetData = resData;
        this.pullSheetTemp = resData;
        this.totalRecords = resData?.length;
        this.exportDisable = false;
        let tempObj = JSON.parse(JSON.stringify(submitObj));
        EncryptUtility.localStorageEncrypt("pullSheetFilterSearch", JSON.stringify(tempObj));
        this.uniqueStatus = [...new Map(this.pullSheetTemp.map((item) => [item["Status"], item.Status])).values()];
        this.uniqueCarrier = [...new Map(this.pullSheetTemp.map((item) => [item["SLevel"], item.SLevel])).values()];
        this.uniqueOtype = [...new Map(this.pullSheetTemp.map((item) => [item["Order_Type"], item.Order_Type])).values()];
        this.arrayData = [
          { id: 1, label: "Carrier", array: this.uniqueCarrier },
          { id: 2, label: "Status", array: this.uniqueStatus },
          { id: 3, label: "Order Type", array: this.uniqueOtype },
        ];
        EncryptUtility.localStorageEncrypt("filterObjects", JSON.stringify(this.arrayData));
        this.$vuetify.goTo(0);
        EncryptUtility.localStorageEncrypt("pullSheetQuickSearch", "");
        this.setAutoExpanded();
      }
    },
    clearFilter() {
      this.arrayData = [];
      this.selectedProcess = "";
      this.selectedBusiness = "";
      this.selectedCountry = "";
      this.selectedProject = "";
      this.soSearch = "";
      this.poSearch = "";
      this.disableProject = true;
      this.disableBusiness = true;
      this.disableOrderType = true;
      this.disableCarrier = true;
      this.disableRun = true;
      this.disableCountry = true;
      this.disableWarehouse = true;
      this.disablePartNumber = true;
      this.projectIds = [];
      this.businessIds = [];
      this.orderTypes = [];
      this.carrierList = [];
      this.carrierIds = [];
      this.countryLists = [];
      this.warehouseIds = [];
      this.partNumIds = [];
      this.statusList = [];
      this.selectedStatus = "";
      this.orderFilterJSON.process_list = [];
      this.orderFilterJSON.status_list = [];
      this.orderFilterJSON.projkey_list = [];
      this.orderFilterJSON.bukey_list = [];
      this.orderFilterJSON.otype_list = [];
      this.orderFilterJSON.slkey_list = [];
      this.orderFilterJSON.country_list = [];
      this.orderFilterJSON.warekey_list = [];
      this.orderFilterJSON.part_number = [];
      this.orderFilterJSON.status_list = [];
      EncryptUtility.localStorageEncrypt("pullSheetQuickSearch", "");
      EncryptUtility.localStorageEncrypt("filterObjects", "");
      EncryptUtility.localStorageEncrypt("pullSheetFilterSearch", "");
      this.pullSheetData = [];
      this.showFilter = false;
      this.totalRecords = 0;
      this.expanded = [];
      this.exportDisable = true;
      this.$refs.filterSearchForm.resetValidation();
    },
    async onClickSearch() {
      this.selectedOrders = [];
      this.showFilter = false;
      this.selectedProcess = "";
      this.selectedProject = "";
      this.selectedBusiness = "";
      this.selectedStatus = "";
      this.selectedCountry = "";
      this.disableProject = true;
      this.disableBusiness = true;
      this.disableCarrier = true;
      this.disableRun = true;
      this.disableCountry = true;
      let searchObj = {
        user_id: this.userId,
        type: this.poSearch ? "PO" : "SO",
        ordno: this.poSearch ? this.poSearch : this.soSearch,
      };
      let resData = await shippingService.onSearchPullSheet("post", searchObj);
      if (resData?.message == "NA" || !resData) {
        let Alert = {
          type: "error",
          isShow: true,
          message: "No Result Found",
        };
        this.$store.commit("ConfigModule/Alert", Alert);
        this.totalRecords = 0;
        this.pullSheetData = [];
        this.expanded = [];
        EncryptUtility.localStorageEncrypt("pullSheetQuickSearch", "");
      } else {
        this.orderType = resData[0]?.Type == "SO" ? "SO" : "PO";
        resData.forEach((item) => {
          item.OrderDate = Utility.displayDateFormat(item.OrderDate);
          item.ReqDate = item.ReqDate ? Utility.displayDateFormat(item.ReqDate) : "";
          item.Ship_By_Date = item.Ship_By_Date ? Utility.displayDateFormat(item.Ship_By_Date, "MM/DD/YYYY hh:mm:ss") : "";
          item.HireDate = item.HireDate ? Utility.displayDateFormat(item.HireDate, "MM/DD/YYYY") : "";
        });
        this.pullSheetData = resData;
        this.exportDisable = false;
        this.totalRecords = resData?.length;
        this.setAutoExpanded();
        EncryptUtility.localStorageEncrypt("pullSheetQuickSearch", JSON.stringify(searchObj));
        EncryptUtility.localStorageEncrypt("pullSheetFilterSearch", "");
        this.$refs.filterSearchForm.resetValidation();
      }
    },
    async filteredValues(value) {
      let filteredData = [...this.pullSheetTemp];
      // If value is "clear", reset to original
      if (value === "clear") {
        this.filterValueUpdate(this.pullSheetTemp);
        return;
      }
      // Map of filter functions
      const filters = {
        1: (data, value) => data.filter((el) => el.SLevel === value),
        2: (data, value) => data.filter((el) => el.Status === value),
        3: (data, value) => data.filter((el) => el.Order_Type === (value === "< BLANK >" ? "" : value)),
      };
      // Apply each filter in the object
      Object.entries(value).forEach(([key, val]) => {
        const filterFn = filters[key];
        if (filterFn) {
          filteredData = filterFn(filteredData, val);
        }
      });
      // Update UI with filtered data
      this.filterValueUpdate(filteredData);
    },
applyTopFilters() {
  let filteredData = [...this.pullSheetTemp];

  if (this.filterCarrier) {
    filteredData = filteredData.filter((el) => el.SLevel === this.filterCarrier);
  }
  if (this.filterStatus) {
    filteredData = filteredData.filter((el) => el.Status === this.filterStatus);
  }
  if (this.filterOrderType) {
    filteredData = filteredData.filter((el) => el.Order_Type === (this.filterOrderType === "< BLANK >" ? "" : this.filterOrderType));
  }

  this.filterValueUpdate(filteredData);
},
clearTopFilters() {
  this.filterCarrier = "";
  this.filterStatus = "";
  this.filterOrderType = "";
  this.filterValueUpdate(this.pullSheetTemp);
},
    filterValueUpdate(data) {
      this.totalRecords = data.length;
      this.pullSheetData = data;
      this.exportDisable = false;
      this.setAutoExpanded();
    },
    //Pull sheet details
    pullSheetDetails(item) {
      let LoaderDialog = {
        visible: true,
        title: "Please Wait...",
      };
      this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
      let obj = {
        user_id: parseInt(this.userId),
        po_id: item.Type == "PO" ? item.po_id : 0,
        so_id: item.Type == "SO" ? item.so_id : 0,
        purno: "",
        sono: "",
      };
      this.axios
        .post("sh/shipping_pullsheet_report", obj)
        .then((response) => {
          if (response.status == 200 || response.status == 204) {
            let responseData = response.data.body.message;
            this.pullSheetLink = "";
            this.pullSheetLink = responseData;
            this.pullSheetDialog = true;
          } else {
            LoaderDialog.visible = false;
            this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
            let Alert = {
              type: "error",
              isShow: true,
              message: response?.data?.message ? response.data.message : "Error fetching pull sheet details",
            };
            this.$store.commit("ConfigModule/Alert", Alert);
          }
          LoaderDialog.visible = false;
          this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
        })
        .catch((error) => {
          this.pullSheetDialog = false;
          LoaderDialog.visible = false;
          this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
          let Alert = {
            type: "error",
            isShow: true,
            message: error?.response?.data?.message ? error.response.data.message : "Error fetching pull sheet details",
          };
          this.$store.commit("ConfigModule/Alert", Alert);
        });
    },
    //Printing the Pull sheet
    printPullSheet() {
      if (EncryptUtility.localStorageDecrypt("defaultName") !== null && EncryptUtility.localStorageDecrypt("defaultName") !== undefined) {
        Utility.printZPLPDF(this.pullSheetLink, EncryptUtility.localStorageDecrypt("defaultName"));
      } else {
        let Alert = {
          type: "error",
          isShow: true,
          message: "Default Printer is not configured, please configure printer.",
        };
        this.$store.commit("ConfigModule/Alert", Alert);
      }
    },
    resetFunction() {
      this.soSearch = "";
      this.poSearch = "";
      this.clearFilter();
      this.showFilter = false;
      EncryptUtility.localStorageEncrypt("pullSheetQuickSearch", "");
      EncryptUtility.localStorageEncrypt("pullSheetFilterSearch", "");
      this.expanded = [];
      this.exportDisable = true;
    },
    //File name
    fileName() {
      this.excelName =
        "Generate_Pull_Sheet_" + new Date().toISOString().replace("T", "_").replace("Z", "").replace(".", "").replaceAll("-", "_") + ".xls";
    },
    async statusAPI(data) {
      this.orderFilterJSON.bukey_list = [];
      this.orderFilterJSON.bukey_list.push(data);
      let statusObj = {
        UserID: this.userId,
        ddl_pass: 9,
        process_list: JSON.stringify(this.orderFilterJSON.process_list),
        projkey_list: JSON.stringify(this.orderFilterJSON.projkey_list),
        bukey_list: JSON.stringify(this.orderFilterJSON.bukey_list),
        otype_list: "",
        slkey_list: "",
        country_list: "",
        warekey_list: "",
        status_list: "",
      };
      let statusData = await shippingService.generatePullSheetFilters("post", statusObj);
      this.statusList = statusData;
    },
    customSort(items, sortBy, sortDesc) {
      const sortKey = sortBy[0];
      const isDesc = sortDesc[0];
      return items.slice().sort((a, b) => {
        let valA = a[sortKey];
        let valB = b[sortKey];
        // Handle nullable dates
        if (sortKey === "Ship_By_Date" || sortKey === "OrderDate") {
          valA = valA ? new Date(valA).getTime() : null;
          valB = valB ? new Date(valB).getTime() : null;
        }
        // Handle nullable strings
        if (typeof valA === "string" || typeof valB === "string") {
          valA = valA ? valA.toLowerCase() : null;
          valB = valB ? valB.toLowerCase() : null;
        }
        // Null-safe comparison logic (shared for both types)
        if (valA === null && valB === null) return 0;
        if (valA === null) return isDesc ? -1 : 1;
        if (valB === null) return isDesc ? 1 : -1;
        if (valA < valB) return isDesc ? 1 : -1;
        if (valA > valB) return isDesc ? -1 : 1;
        return 0;
      });
    },
    removeSelectedOrder(order) {
      this.selectedOrders = this.selectedOrders.filter((x) => x.TempId !== order.TempId);
    },
    clearAllSelectedOrders() {
      this.selectedOrders = [];
    },
  },
  components: {
    breadcrumbComp,
    html2pdf,
    BackToTop,
    PrinterDetails,
    ReadMore,
  },
};
